import { apiGet, apiPatch } from '../../../shared/api-client/index.js';

export interface ConversionDigestSettings {
  available: boolean;
  enabled: boolean;
  deliveryHour: number;
  stagnationDays: number;
  locale: 'ru' | 'en';
  chatBindingId: string | null;
  stateVersion: number | null;
}

export interface UpdateConversionDigestSettings {
  enabled: boolean;
  deliveryHour: number;
  stagnationDays: number;
  locale: 'ru' | 'en';
  expectedStateVersion: number | null;
}

export const conversionDigestQueryKey = (workspaceId: string) =>
  ['conversion-digest-subscription', workspaceId] as const;

export const getConversionDigestSettings = (): Promise<ConversionDigestSettings> =>
  apiGet('/conversion-digest/subscription');

export const patchConversionDigestSettings = (
  input: UpdateConversionDigestSettings,
): Promise<ConversionDigestSettings> => apiPatch('/conversion-digest/subscription', input);
